import { render, staticRenderFns } from "./PageMenusListe.vue?vue&type=template&id=251b954c&scoped=true&"
import script from "./PageMenusListe.vue?vue&type=script&lang=js&"
export * from "./PageMenusListe.vue?vue&type=script&lang=js&"
import style0 from "./PageMenusListe.vue?vue&type=style&index=0&id=251b954c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251b954c",
  null
  
)

export default component.exports